/**
 * RetiroHost — el cuadro que pregunta por qué se retira un mensaje (ver src/lib/motivoRetiro.js). Un solo cuadro para toda la app.
 * Una sola pantalla y un toque por motivo: retirar un mensaje que se fue al cliente por error tiene que ser rápido.
 */
import { useEffect, useRef, useState } from "react";
import { MOTIVOS_RETIRO, registrarHostRetiro } from "../lib/motivoRetiro.js";

export default function RetiroHost() {
  const [pedido, setPedido] = useState(null);
  const [otro, setOtro] = useState(false);
  const [texto, setTexto] = useState("");
  const ta = useRef(null);

  useEffect(() => {
    registrarHostRetiro(true);
    const f = (e) => { setOtro(false); setTexto(""); setPedido(e.detail); };
    window.addEventListener("crew-pedir-retiro", f);
    return () => { window.removeEventListener("crew-pedir-retiro", f); registrarHostRetiro(false); };
  }, []);
  useEffect(() => { if (otro) requestAnimationFrame(() => ta.current?.focus()); }, [otro]);
  if (!pedido) return null;

  const cerrar = (valor) => { pedido.resolver(valor); setPedido(null); };
  const pedir = pedido.modo === "pedir";
  return (
    <div className="fixed inset-0 z-[90] grid place-items-end bg-black/40 sm:place-items-center" role="dialog" aria-modal="true" aria-label={pedir ? "Pedir el retiro del mensaje" : "Retirar el mensaje"} onKeyDown={(e) => { if (e.key === "Escape") cerrar(null); }}>
      <div className="w-full max-w-md rounded-t-3xl bg-card p-5 shadow-xl sm:rounded-3xl">
        <h2 className="text-[18px] font-extrabold">{pedir ? "Pedir el retiro del mensaje" : "Retirar el mensaje"}</h2>
        <p className="mt-0.5 text-[13.5px] leading-snug text-muted-foreground">
          {pedir
            ? `Pasaron más de ${pedido.plazoH} horas, así que lo resuelve el nivel más alto. Le llega un aviso al instante.`
            : pedido.alCliente
              ? "Sale del chat del cliente en el momento. No se borra: queda registrado quién lo retiró, cuándo y por qué, y si el cliente ya lo había visto."
              : "No se borra: queda registrado quién lo retiró, cuándo y por qué."}
        </p>
        {!otro ? (
          <div className="mt-3 flex flex-col gap-2">
            {MOTIVOS_RETIRO.map((m) => (
              <button key={m.id} type="button" onClick={() => (m.id === "otro" ? setOtro(true) : cerrar({ motivo: m.id }))}
                className="min-h-12 rounded-2xl border border-border px-4 text-left text-[15px] font-bold hover:bg-muted active:bg-muted">{m.texto}</button>
            ))}
          </div>
        ) : (
          <>
            <textarea ref={ta} value={texto} onChange={(e) => setTexto(e.target.value)} rows={3} maxLength={300} aria-label="Motivo del retiro" placeholder="Contá brevemente por qué"
              className="mt-3 w-full resize-none rounded-2xl border border-input bg-background p-3 text-[15px] leading-snug outline-none focus-visible:ring-2 focus-visible:ring-ring/60 max-md:text-[16px]" />
            <div className="mt-3 flex justify-end gap-2">
              <button type="button" onClick={() => setOtro(false)} className="h-11 rounded-full px-5 text-[14px] font-bold text-muted-foreground hover:bg-muted">Volver</button>
              <button type="button" disabled={texto.trim().length < 3} onClick={() => cerrar({ motivo: "otro", motivo_texto: texto.trim() })} className="h-11 rounded-full bg-red-600 px-6 text-[14px] font-extrabold text-white disabled:opacity-40">{pedir ? "Pedir retiro" : "Retirar"}</button>
            </div>
          </>
        )}
        {!otro && <div className="mt-3 flex justify-end"><button type="button" onClick={() => cerrar(null)} className="h-10 rounded-full px-5 text-[14px] font-bold text-muted-foreground hover:bg-muted">Cancelar</button></div>}
      </div>
    </div>
  );
}
